"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingStatus = void 0;
var BillingStatus;
(function (BillingStatus) {
    BillingStatus["BILLABLE"] = "Billable";
    BillingStatus["NON_BILLABLE"] = "Non-billable";
})(BillingStatus = exports.BillingStatus || (exports.BillingStatus = {}));
